module.exports = "<div class=\"accordion\">\n  <ng-content></ng-content>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/typescripts/pro/accordion/components/squeezebox.html
// module id = ./src/app/typescripts/pro/accordion/components/squeezebox.html
// module chunks = main